import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { addFavouriteGame, getAllFavouriteGames, getAllGames, getViewAllFavoriteGamesList, removeFavouriteGame } from 'redux-thunk/thunk/game.thunk'
import { setViewAllGames } from 'redux-thunk/redux/slices/games.slice'
import { openWarningToaster } from 'helpers/toaster.helpers'
import { CASINO_TABS, GAME_CATEGORY, LOADER_HANDLER_TYPES } from 'constants/index'

export const useAllGames = ({ navRef, tab, provider, gameCategory = '', searchGame = '' }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const [items, setItems] = useState(null)
  const [gameId, setGameId] = useState(null)
  const { viewAllGames } = useSelector(state => state.games)
  const {
    [LOADER_HANDLER_TYPES.categoryWiseGamesList]: loading,
    [LOADER_HANDLER_TYPES.submit]: actionLoading
  } = useSelector(state => state.loader)
  const { loginData } = useSelector(state => state.auth)
  const { user } = useSelector(state => state?.user)
  const { favGame } = useSelector(state => state?.lobby)
  const isLoggedIn = loginData?.accessToken

  const limit = 30
  const isFavourite = gameCategory === GAME_CATEGORY.FAVOURITE

  useEffect(() => {
    dispatch(setViewAllGames(null))
    if (isLoggedIn && isFavourite && favGame) {
      window.scrollTo({ top: navRef?.current?.offsetTop - 180 })
      dispatch(getViewAllFavoriteGamesList({ data: { offset: 0, limit, gameCategory: favGame, name: searchGame } }))
    } else if (isLoggedIn && isFavourite) {
      window.scrollTo({ top: navRef?.current?.offsetTop - 180 })
      dispatch(getAllFavouriteGames({ data: { limit, offset: 0, provider, name: searchGame } }))
    }
  }, [gameCategory, searchGame])

  // Favourites ends

  useEffect(() => {
    !isFavourite && viewAllGames && setItems(viewAllGames)
  }, [viewAllGames])

  useEffect(() => {
    if (!isFavourite) {
      if ((tab !== CASINO_TABS.LOBBY) || (tab !== CASINO_TABS.ORIGINALS)) {
        window.scrollTo({ top: navRef?.current?.offsetTop - 180 })
        if (gameCategory) {
          fetchNewData({ provider: '', type: gameCategory, name: searchGame })
        } else { // if user changes tab for provider
          fetchNewData({ provider, type: '' })
        }
      }
    }
  }, [provider, gameCategory, tab, searchGame, user?.id])

  const favouriteGameHandler = (e, game) => {
    setGameId(game?.id)
    e?.stopPropagation()
    if (game?.isFavourite || isFavourite) {
      dispatch(removeFavouriteGame({ game }))
    } else {
      dispatch(addFavouriteGame({ game }))
    }
  }

  const fetchMoreFavouriteGames = () => {
    if (favGame) {
      dispatch(getViewAllFavoriteGamesList({
        data:
        {
          offset: items?.rows?.length,
          limit,
          gameCategory: favGame,
          name: searchGame
        }
      }))
    } else {
      dispatch(getAllFavouriteGames(
        {
          data: {
            limit,
            offset: items?.rows?.length,
            provider,
            type: gameCategory,
            name: searchGame
          }
        }))
    }
  }

  const onGamePlayRedirect = useCallback((game) => {
    const gameName = game.gameName.toLowerCase().replace(/\s+/g, '-')
    if (isLoggedIn) {
      history?.push(`/casino/play-game/${gameName}`, { game, demo: false })
    } else if (game.hasDemo) {
      history?.push(`/casino/play-game/${gameName}`, { game, demo: true })
    } else {
      openWarningToaster({ message: t('LoginRequired') })
    }
  }, [loginData])

  const fetchMore = () => {
    dispatch(getAllGames({
      data:
      {
        limit,
        offset: items?.rows?.length,
        type: gameCategory,
        provider,
        userId: user?.id,
        name: searchGame
      }
    }))
  }

  const fetchNewData = ({ provider, type, name = '' }) => {
    // setProvider(provider)
    if (isFavourite) {
      dispatch(getAllFavouriteGames({ data: { limit, offset: 0, provider, userId: user?.id, name } }))
    } else {
      if ((tab !== CASINO_TABS.ORIGINALS) && (tab !== CASINO_TABS.ALL_PROVIDERS)) {
        dispatch(getAllGames({ data: { limit, offset: 0, provider, type, userId: user?.id, name } }))
      }
    }
  }

  return {
    items,
    loading,
    isFavourite,
    isLoggedIn,
    fetchMore,
    favouriteGameHandler,
    fetchMoreFavouriteGames,
    onGamePlayRedirect,
    gameId,
    actionLoading,
    t
  }
}
